// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityFiltersPage-EntityList-EntityActions-EntityActions-module__menuButton--n2YBW {
  width: 32px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityFiltersPage/EntityList/EntityActions/EntityActions.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF","sourcesContent":[".menuButton {\n  width: 32px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuButton": `src-pages-EntityFiltersPage-EntityList-EntityActions-EntityActions-module__menuButton--n2YBW`
};
export default ___CSS_LOADER_EXPORT___;
